/**
 * Path shim: the package export map aliases `./statsig/provider` to
 * `StatsigProviderWrapper.tsx`, but path-based resolvers (tsconfig `paths`
 * wildcards, next/jest's SWC rewrite, jest moduleNameMapper) resolve the
 * subpath literally — this file makes both roads lead to the same module.
 */
export * from "./StatsigProviderWrapper";
